import { AbstractControl, FormGroup } from '@angular/forms';
import { Constants } from 'src/app/core/constants';

export function ValidatePackageLevelFields(g: FormGroup, formErrors: any, checkDirty?: boolean, checkOnlyRequired: boolean = false) {
  formErrors = ValidatePackageMaterialId(g, formErrors, checkDirty);
  formErrors = ValidatePackagelevelTemplateId(g, formErrors, checkDirty);
  if (!checkOnlyRequired) {
  formErrors = ValidateNoOfLayers(g, formErrors, checkDirty);
  formErrors = ValidateContainersPerLayers(g, formErrors, checkDirty);
  // TMS-6253 dims are getting checked already with Helper.ValidatePackageTemplateLevelFields
  // formErrors = ValidateLength(g, formErrors, checkDirty);
  // formErrors = ValidateWidth(g, formErrors, checkDirty);
  // formErrors = ValidateHeight(g, formErrors, checkDirty);
  formErrors = ValidateTareWeight(g, formErrors, checkDirty);
  }
  formErrors = ValidateQPC(g, formErrors, checkDirty, checkOnlyRequired);
  formErrors = ValidateDunnageType(g, formErrors, checkDirty);
  return formErrors;
}

function ValidatePackageMaterialId(g: FormGroup, formErrors: any, checkDirty?: boolean) {
  if (IsPrimaryLevel(g)) {
      ValidateForNumberRequiredMinValue(g, formErrors, 'PackageMaterialId', 0);
  }
  return formErrors;
}

function ValidatePackagelevelTemplateId(g: FormGroup, formErrors: any, checkDirty?: boolean) {
  const packageTemplateOption = g.get('PackageTemplateOption').value;
  const materialId = g.get('PackageMaterialId').value;

  if (IsPrimaryLevel(g)) {
      ValidateForNumberRequiredMinValue(g, formErrors, 'PackagelevelTemplateId', 0);
  }

  if (materialId && packageTemplateOption.TeslaEquipmentCode == null) {
      g.controls['PackagelevelTemplateId'].setErrors({'required': true});
      formErrors['PackagelevelTemplateId'] =  'This field is required';
  }

  if ((IsSecondaryLevel(g) || IsTertiaryLevel(g)) && materialId) {
    ValidateForNumberRequiredMinValue(g, formErrors, 'PackagelevelTemplateId', 0);
  }
  return formErrors;
}

function ValidateNoOfLayers(g: FormGroup, formErrors: any, checkDirty?: boolean) {
  // mandatory for secondary only if user intends to create secondary i.e. after selecting material
  const materialId = g.get('PackageMaterialId').value;
  if ((IsSecondaryLevel(g) || IsTertiaryLevel(g)) && materialId) {
    ValidateForNumberRequiredMinValue(g, formErrors, 'NoOfLayers', 0);
  }
  return formErrors;
}

function ValidateQPC(g: FormGroup, formErrors: any, checkDirty?: boolean, checkOnlyRequired: boolean = false) {
  if (IsPrimaryLevel(g)) {
    if (checkOnlyRequired) {
      ValidateForNumberRequired(g, formErrors, 'QPC');
    } else {
      ValidateForNumberRequiredMinValue(g, formErrors, 'QPC', 0);
    }
  }
  return formErrors;
}

function ValidateLength(g: FormGroup, formErrors: any, checkDirty?: boolean) {
  if (IsPrimaryLevel(g)) {
    ValidateForNumberRequiredMinValue(g, formErrors, 'Length', Constants.DimensionsMinLength_NotShippable);
  }
  // mandatory for secondary only if user intends to create secondary i.e. after selecting material
  const materialId = g.get('PackageMaterialId').value;
  if ((IsSecondaryLevel(g) || IsTertiaryLevel(g)) && materialId) {
    ValidateForNumberRequiredMinValue(g, formErrors, 'Length', Constants.DimensionsMinLength_NotShippable);
  }
  return formErrors;
}

function ValidateWidth(g: FormGroup, formErrors: any, checkDirty?: boolean) {
  if (IsPrimaryLevel(g)) {
    ValidateForNumberRequiredMinValue(g, formErrors, 'Width', Constants.DimesionsMinWidth_Shippable);
  }
  // mandatory for secondary only if user intends to create secondary i.e. after selecting material
  const materialId = g.get('PackageMaterialId').value;
  if ((IsSecondaryLevel(g) || IsTertiaryLevel(g)) && materialId) {
    ValidateForNumberRequiredMinValue(g, formErrors, 'Width', Constants.DimesionsMinWidth_NotShippable);
  }
  return formErrors;
}

function ValidateHeight(g: FormGroup, formErrors: any, checkDirty?: boolean) {
  if (IsPrimaryLevel(g)) {
    ValidateForNumberRequiredMinValue(g, formErrors, 'Height', Constants.DimensionsMinHeight_NotShippable);
  }
  // mandatory for secondary only if user intends to create secondary i.e. after selecting material
  const materialId = g.get('PackageMaterialId').value;
  if ((IsSecondaryLevel(g) || IsTertiaryLevel(g)) && materialId) {
    ValidateForNumberRequiredMinValue(g, formErrors, 'Height', Constants.DimensionsMinHeight_NotShippable);
  }
  return formErrors;
}

function ValidateTareWeight(g: FormGroup, formErrors: any, checkDirty?: boolean) {
  if (IsPrimaryLevel(g)) {
    ValidateForNumberRequiredMinValue(g, formErrors, 'TareWeight', 0);
  }

  const materialId = g.get('PackageMaterialId').value;
  if ((IsSecondaryLevel(g) || IsTertiaryLevel(g)) && materialId) {
    ValidateForNumberRequiredMinValue(g, formErrors, 'TareWeight', 0);
  }
  if (formErrors['TareWeight'] === '') {
    ValidateForPattern(g, formErrors, 'TareWeight');
  }
  return formErrors;
}

function ValidateDunnageType(g: FormGroup, formErrors: any, checkDirty?: boolean) {
  // TMS-6391 dunnage type is now required
  // do validation only if user intends to fill the package level data, good indication is whether package material is filled
  const materialId = g.get('PackageMaterialId').value;
  if (materialId)  {
  const fieldName = 'proposalPackageLevelDunnageTypes';
  const fieldValue = g.get(fieldName).value;
  if (fieldValue == null || (!Array.isArray(fieldValue) || !fieldValue.length)) {
    g.controls[fieldName].setErrors({'required': true});
   formErrors[fieldName] =  'This field is required';
  }
  }
  // const isDunnageRequired = g.get('IsDunnageRequired').value;
  // if ((IsPrimaryLevel(g) || IsSecondaryLevel(g) || IsTertiaryLevel(g))) {
  //   if (isDunnageRequired) {
  //     ValidateForStringRequiredMinMaxLength(g, formErrors, 'DunnageType', 1, 255);
  //     ValidateForNumberRequiredMinValue(g, formErrors, 'proposalPackageLevelDunnageTypes', 0);
  //   }
  // }
  return formErrors;
}

function ValidateContainersPerLayers(g: FormGroup, formErrors: any, checkDirty?: boolean) {
  // mandatory for secondary only if user intends to create secondary i.e. after selecting material
  const materialId = g.get('PackageMaterialId').value;
  if ((IsSecondaryLevel(g) || IsTertiaryLevel(g)) && materialId) {
    ValidateForNumberRequiredMinValue(g, formErrors, 'ContainersPerLayer', 0);
  }
  return formErrors;
}

function ValidateForNumberRequiredMinValue(g: FormGroup, formErrors: any, fieldName: string, minValue: Number) {
  const fieldValue = g.get(fieldName).value;
  if (fieldName == 'proposalPackageLevelDunnageTypes') {
     if (isNaN(fieldValue)) {
        return;
     }
  }
  if (fieldValue == null || isNaN(fieldValue)) {
    g.controls[fieldName].setErrors({'required': true});
   formErrors[fieldName] =  'This field is required';
  } else if (fieldValue <= minValue) {
    g.controls[fieldName].setErrors({'min': true});
    formErrors[fieldName] = 'Value should be greater than ' + minValue;
  } else {
    return;
  }
}

function ValidateForNumberRequired(g: FormGroup, formErrors: any, fieldName: string) {
  const fieldValue = g.get(fieldName).value;
  if (fieldName == 'proposalPackageLevelDunnageTypes') {
     if (isNaN(fieldValue)) {
        return;
     }
  }
  if (fieldValue == null || isNaN(fieldValue)) {
    g.controls[fieldName].setErrors({'required': true});
   formErrors[fieldName] =  'This field is required';
  } else {
    return;
  }
}

function ValidateForPattern(g: FormGroup, formErrors: any, fieldName: string) {
  const fieldValue = g.get(fieldName).value;
  if (String(fieldValue).includes('.')) {
    const deicmalVals = String(fieldValue).substring(String(fieldValue).indexOf('.') + 1, String(fieldValue).length);
    if (deicmalVals.length > 8 && fieldValue != null) {
      g.controls[fieldName].setErrors({'pattern': true});
      formErrors[fieldName] = 'Max decimal places exceeded.';
    } else {
      return;
    }
  } else {
    return;
  }
}

function ValidateForStringRequiredMinMaxLength(g: FormGroup, formErrors: any, fieldName: string, minLength: Number, maxLength: Number) {
  const fieldValue = g.get(fieldName).value;
  if (isEmptyOrSpaces(fieldValue) || fieldValue.length < minLength) {
    g.controls[fieldName].setErrors({'required': true});
   formErrors[fieldName] =  'This field is required';
  } else if (fieldValue.length > maxLength) {
    g.controls[fieldName].setErrors({'max': true});
    formErrors[fieldName] = 'Maximum number of characters=' + maxLength;
  } else {
    return;
  }
}

function IsPrimaryLevel(g: FormGroup): boolean {
  return (g.get('PackageLevelId').value == 1);
}

function IsSecondaryLevel(g: FormGroup): boolean {
  return (g.get('PackageLevelId').value == 2);
}

function IsTertiaryLevel(g: FormGroup): boolean {
  return (g.get('PackageLevelId').value == 3);
}

function IsPrimaryOrSecondaryLevel(g: FormGroup): boolean {
  return ((g.get('PackageLevelId').value == 1) || (g.get('PackageLevelId').value == 2));
}

function isEmptyOrSpaces(str: string) {
  return str === null || str.match(/^ *$/) !== null;
}

function isNAN(value: any) {
  return Number.isNaN(value as any);
}